import React, { useState, useEffect, useRef } from 'react';
import Modal from '@salesforce/design-system-react/components/modal';
import Button from '@salesforce/design-system-react/components/button';
import Input from '@salesforce/design-system-react/components/input';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import { ACTION_TYPES } from '../../constants/types';
import { accountsSelector, pauseSyncAccounts } from '../../store/accounts/slice';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const ActionAccounts = (props) => {
  const { modelData, closeModal } = props;
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(false);
  const { loading, success, message } = useSelector(accountsSelector);
  const [name, setName] = useState('');
  const [actionId, setActionId] = useState("")
  const formikRef = useRef();

  useEffect(() => {
    setIsOpen(modelData.open);
    setName(modelData.name);
    setActionId(modelData.id);
  }, [modelData]);

  useEffect(() => {
    success &&
      showToast &&
      toast.success(message, {
        id: 'hedge-fund-modal-action',
      });
    setShowToast(false);
  }, [success,showToast,message]);

  const toggleOpen = () => {
    formikRef.current?.resetForm()
    closeModal({
      open: false,
      type: '',
    });
  };

  const getInfo = (type) => {

    if (type === ACTION_TYPES.PAUSE) {
      return `Are you sure you want to suspend and pause sync the Hedge Fund Account ? The user will not be able to login in into the account.`;
    }

    if (type === ACTION_TYPES.RESUME) {
      return `Are you sure you want to enable and resume pause sync  User ? The user will  be able to login in into the account.`;
    }

    if (type === ACTION_TYPES.REMOVE) {
      return `Are you sure you want to remove the Hedge Fund Account ? This can't be undone.`;
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize={true}
      initialValues={{
        name: '',
        status: !modelData.isSyncPaused,
        id: '',
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string()
          .required('Required')
          .test('match', `Must match with Hedge Fund Account's name`, (val) => val === name.trim()),
        status: Yup.boolean()
      })}
      onSubmit={(values, { setSubmitting, resetForm }, isValid) => {
        setShowToast(true);
        setSubmitting(true);
        const data = {
          name: values.name,
          status: values.status,
          // account_type:"defi"
        };

        /**
         * check if key is empty, and remove empty key.
         */
        // Object.keys(data).forEach((key) => {
        //   if (!data[key]) delete data[key];
        // });

        const userDetails = {
          id: actionId,
          status: data,
        };

        (modelData.type === "Pause" || modelData.type === "Resume") && dispatch(actionId && pauseSyncAccounts(userDetails)).then((res) => {
          if (res?.payload?.data) {
            resetForm();
            closeModal({
              open: false
            });
          }
        });
        // if(modelData.type === "remove") {
        //    dispatch(actionId && deleteHedgeFundUser(userDetails));
        //    dispatch(getHedgeFunds());
        // }

        // if (!loading) {
        //   resetForm();
        //   closeModal({
        //     open: false,
        //     type: '',
        //   });
        // }
      }}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
        } = props;
        return (
          <div>
            <Modal
              disableClose
              ariaHideApp={false}
              isOpen={isOpen}
              size="small"
              containerClassName="small-modal"
              footer={[
                <Button className='modal-cancel-button' key="cancel" label="Cancel" onClick={toggleOpen} />,
                <IconSettings iconPath="/assets/icons">
                  <Button
                    className='modal-save-button'
                    key="save"
                    label={
                      loading ? (
                        <span>Loading</span>
                      ) : (
                        <span>{(modelData.type)}</span>
                      )
                    }
                    disabled={isSubmitting || !isValid || values.name === ''}
                    onClick={handleSubmit}
                    iconCategory='utility'
                    iconName={modelData.type === 'Pause' ? 'pause' : 'play'}
                    iconPosition='left'
                  />
                </IconSettings>,
              ]}
              onRequestClose={toggleOpen}
              heading={`${(modelData.type)} Account`}
            >
              <section className="slds-p-around_large">
                <form
                  onSubmit={handleSubmit}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      handleSubmit();
                    }
                  }}
                >
                  <Toaster position="top-right" reverseOrder={false} />
                  <p className="mb-10">{getInfo(modelData.type)}</p>

                  <p className="mb-10">
                    Please type the Hedge Fund Account's name <b>{name}</b> in the box below to
                    continue.
                  </p>

                  <div className="slds-m-bottom_large">
                    <Input
                      id="name"
                      name="name"
                      placeholder={modelData.name}
                      required
                      value={values.name || ''}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={classNames(errors.name && touched.name && 'slds-has-error')}
                    />
                    {errors.name && touched.name && (
                      <div className="slds-form-element__help">{errors.name}</div>
                    )}
                  </div>
                </form>
              </section>
            </Modal>
          </div>
        );
      }}
    </Formik>
  );
};

export default ActionAccounts;
